var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navbar" }, [
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "justify-content": "flex-start",
          "flex-grow": "1"
        }
      },
      [
        _c("div", {
          style: {
            width: _vm.sidebar.opened ? (_vm.isZh ? "160px" : "220px") : "1px"
          }
        })
      ]
    ),
    _c(
      "div",
      { staticClass: "right-menu" },
      [
        _c(
          "div",
          {
            staticStyle: { display: "inline-block" },
            attrs: { id: "account-info" }
          },
          [
            _c(
              "el-tooltip",
              {
                attrs: {
                  content: _vm.tenantName,
                  effect: "dark",
                  placement: "bottom"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      "padding-right": "20px"
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("Tool.platformId")) + "：")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { color: "#999" } }, [
                      _vm._v(_vm._s(_vm.tenantId))
                    ])
                  ]
                )
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "inline-block",
                  "padding-right": "20px"
                }
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.$t("Tool.User")) + "：")]),
                _vm._v(" "),
                _c("span", { staticStyle: { color: "#999" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.isZh
                        ? _vm.$store.getters.userInfo.chineseName
                        : _vm.$store.getters.userInfo.englishName
                    )
                  )
                ])
              ]
            ),
            _vm.$store.getters.userInfo.groupCompany
              ? _c("span", [_vm._v(_vm._s(_vm.$t("Tool.company")) + "：")])
              : _vm._e(),
            _c(
              "el-tooltip",
              {
                attrs: { content: _vm.currentOfficeIdTip, placement: "bottom" }
              },
              [
                _c(
                  "div",
                  { staticClass: "company-select" },
                  [
                    _vm.$store.getters.userInfo.groupCompany
                      ? [
                          _vm.ownedBranchStyle === "level"
                            ? _c("owned-branch-tree", {
                                attrs: {
                                  "office-list": _vm.currentOfficeList,
                                  value: _vm.currentOfficeId,
                                  "width-auto-fit": true,
                                  "min-width": 85,
                                  "max-width": 196
                                },
                                on: {
                                  input: _vm.onOfficeInput,
                                  tipChange: function(p) {
                                    _vm.currentOfficeIdTip = p
                                  }
                                }
                              })
                            : _c("cargo-owned-branch-select", {
                                staticStyle: {
                                  "min-width": "85px",
                                  "max-width": "196px"
                                },
                                attrs: {
                                  value: _vm.currentOfficeId,
                                  "static-options": _vm.currentOfficeList,
                                  "width-auto-fit": true
                                },
                                on: {
                                  input: _vm.onOfficeInput,
                                  tipChange: function(p) {
                                    _vm.currentOfficeIdTip = p
                                  }
                                }
                              })
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _c("span", { staticStyle: { "padding-left": "5px" } }, [
              _vm._v(_vm._s(_vm.$t("Tool.department")) + "：")
            ]),
            _c(
              "el-select",
              {
                staticStyle: { width: "120px" },
                attrs: { filterable: "" },
                model: {
                  value: _vm.currentDeptId,
                  callback: function($$v) {
                    _vm.currentDeptId = $$v
                  },
                  expression: "currentDeptId"
                }
              },
              _vm._l(_vm.currentDeptList, function(dept) {
                return _c("el-option", {
                  key: dept.uuid,
                  attrs: {
                    value: dept.departmentId,
                    label: _vm.isZh ? dept.chineseName : dept.englishName
                  }
                })
              }),
              1
            ),
            _vm.userGroups.length > 0 && _vm.curUserGroup
              ? _c("span", { staticStyle: { "padding-left": "5px" } }, [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_RoleGroup")) + "：")
                ])
              : _vm._e(),
            _vm.userGroups.length > 0 && _vm.curUserGroup
              ? _c(
                  "el-select",
                  {
                    staticStyle: { width: "120px" },
                    attrs: { filterable: "" },
                    on: { change: _vm.changeUserGroup },
                    model: {
                      value: _vm.curUserGroup,
                      callback: function($$v) {
                        _vm.curUserGroup = $$v
                      },
                      expression: "curUserGroup"
                    }
                  },
                  _vm._l(_vm.userGroups, function(group) {
                    return _c("el-option", {
                      key: group.uuid,
                      attrs: { value: group.uuid, label: group.groupName }
                    })
                  }),
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _c("sys-message", {
          ref: "sysMessage",
          staticClass: "right-menu-item",
          attrs: { id: "message-reminder" }
        }),
        _c(
          "el-tooltip",
          {
            attrs: {
              content: _vm.$t("Menu.Menu1"),
              effect: "dark",
              placement: "bottom"
            }
          },
          [
            _c("navbar-menu", {
              staticClass: "right-menu-item",
              attrs: { id: "navbar-menu" }
            })
          ],
          1
        ),
        !_vm.isProd
          ? [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: "前端开发规范",
                    effect: "dark",
                    placement: "bottom"
                  }
                },
                [
                  _c("help-center", {
                    staticClass: "screenfull right-menu-item"
                  })
                ],
                1
              )
            ]
          : _vm._e(),
        _vm.device !== "mobile" && false
          ? [
              _c(
                "div",
                {
                  staticClass: "organization-wrap",
                  staticStyle: {
                    display: "inline-block",
                    "vertical-align": "top",
                    "line-height": "20px",
                    "padding-right": "14px",
                    color: "#97a8be"
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.userInfo.userName) +
                      " | " +
                      _vm._s(_vm.userInfo.departmentName) +
                      " | " +
                      _vm._s(_vm.userInfo.officeName) +
                      " | " +
                      _vm._s(_vm.userInfo.tenantId) +
                      " "
                  )
                ]
              ),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("Message.FullScreen"),
                    effect: "dark",
                    placement: "bottom"
                  }
                },
                [
                  _c("screenfull", {
                    staticClass: "screenfull right-menu-item"
                  })
                ],
                1
              ),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("Menu.HelpCenter"),
                    effect: "dark",
                    placement: "bottom"
                  }
                },
                [
                  _c("help-center", {
                    staticClass: "screenfull right-menu-item"
                  })
                ],
                1
              ),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("Message.EarlyWarningReminder"),
                    effect: "dark",
                    placement: "bottom"
                  }
                },
                [
                  _c("warning-alert", {
                    staticClass: "screenfull right-menu-item"
                  })
                ],
                1
              ),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    scontent: _vm.$t("Message.AnnouncementMessage"),
                    effect: "dark",
                    placement: "bottom"
                  }
                },
                [
                  _c("board-message", {
                    staticClass: "screenfull right-menu-item"
                  })
                ],
                1
              ),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("Menu.OnlineCustomerService"),
                    effect: "dark",
                    placement: "bottom"
                  }
                },
                [
                  _c("custom-service", {
                    staticClass: "screenfull right-menu-item"
                  })
                ],
                1
              ),
              _c("user-info", {
                staticClass: "screenfull right-menu-item",
                on: {
                  "change-password-from-user-info-because-of-shit": function(
                    $event
                  ) {
                    return _vm.$emit(
                      "change-password-from-navbar-because-of-shit"
                    )
                  }
                }
              }),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("Message.Cancellation"),
                    effect: "dark",
                    placement: "bottom"
                  }
                },
                [_c("logout", { staticClass: "screenfull right-menu-item" })],
                1
              )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }